import axios from "axios";
import { header } from "./header";

export const GetInventoryDashboradData = async(obj) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_COMMONINVENTORY}/api/Dashboard/GetInventoryDashboradData?OrgCode=${obj.OrgCode}&OrgBranchCode=${obj.OrgBranchCode}&StartDate=${obj.StartDate}&EndDate=${obj.EndDate}`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }


  export const GetRegDashbroadData = async(obj) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetOrdersDashboardData?OrgCode=${obj.OrgCode}&SubOrgCode=${obj.OrgBranchCode}&StartDate=${obj.StartDate}&EndDate=${obj.EndDate}`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }